module.exports = __webpack_public_path__ + "modules/exam/img/error2.png";